import { Box, RadioGroup, FormControlLabel, Radio, TextField } from '@material-ui/core'
import { usePopup } from 'hooks/usePopup'
import { Loading } from 'pages/Admin/Breaks/styles'
import React, { useState } from 'react'

import {
  ButtonCancel,
  ButtonConfirm,
  Container,
  ContainerButtons,
  InfoCostumer,
  Modal,
  TextConfirmAddBoxes,
  TextConfirmRelease,
  Title,
} from './styles'

interface IModalConfirmConference {
  open: boolean
  handleClose: () => void
  onConfirm: (boxesNumber: number) => void
  data: { orderId: string; boxesNumber: number }
}

export const ModalConfirmConference = ({
  handleClose,
  data,
  onConfirm,
  open,
}: IModalConfirmConference) => {
  const controllerOrder = new AbortController()

  const { addPopup } = usePopup()
  const [isLoading, setIsLoading] = useState(false)
  const [newBoxesQuantity, setNewBoxesQuantity] = useState('')
  const [additionalBoxes, setAdditionalBoxes] = useState<'sim' | 'não' | null>(null)
  const [isConfirmEnabled, setIsConfirmEnabled] = useState(false)

  const handleAdditionalBoxesChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const value = event.target.value as 'sim' | 'não'
    setAdditionalBoxes(value)
    setIsConfirmEnabled(value === 'sim')
    setNewBoxesQuantity('')
  }

  const handleBoxesQuantityChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const value = event.target.value
    setNewBoxesQuantity(value)
    setIsConfirmEnabled(Number(value) > 0)
  }

  const onClose = () => {
    setAdditionalBoxes(null)
    setNewBoxesQuantity('')
    setIsConfirmEnabled(false)
    handleClose()
  }

  const handleConfirm = async () => {
    try {
      setIsLoading(true)
      onConfirm(Number(newBoxesQuantity || 0))
      onClose()
    } catch (error: any) {
      addPopup({
        type: 'error',
        title: 'Ocorreu um erro pra finalizar a conferência',
        description: error?.message || error,
      })
    } finally {
      setIsLoading(false)
    }
  }

  return (
    <>
      <Modal open={open}>
        <Container>
          <Loading loading={isLoading} />
          <Title>Conferir Caixas</Title>
          <InfoCostumer>
          <p>
              N° Pedido: <strong>{data.orderId}</strong>
            </p>
            <p>
              Quantidade de caixas: <strong>{data.boxesNumber} caixa(s)</strong>
            </p>
          </InfoCostumer>
          <TextConfirmAddBoxes>A contagem de caixas está certa?</TextConfirmAddBoxes>
          <Box display="flex" justifyContent="center">
            <RadioGroup row value={additionalBoxes} onChange={handleAdditionalBoxesChange}>
              <FormControlLabel value="sim" control={<Radio />} label="Sim" />
              <FormControlLabel value="não" control={<Radio />} label="Não" />
            </RadioGroup>
          </Box>

          {additionalBoxes === 'não' && (
            <TextField
              type="number"
              label="Quantidade de caixas correta"
              value={newBoxesQuantity}
              onChange={handleBoxesQuantityChange}
              inputProps={{ min: 1 }}
              style={{ width: '80%', marginBottom: '1rem' }}
            />
          )}
          <TextConfirmRelease>Confirmar a conferência desse pedido?</TextConfirmRelease>
          <ContainerButtons>
            <ButtonCancel onClick={handleClose} disabled={isLoading}>
              Cancelar
            </ButtonCancel>
            <ButtonConfirm onClick={handleConfirm} disabled={isLoading || !isConfirmEnabled}>
              Confirmar
            </ButtonConfirm>
          </ContainerButtons>
        </Container>
      </Modal>
    </>
  )
}
